export const downloadCSVFromRequest = (resp) => {
  const filename = resp.headers.get('x-file-name');
  const a = document.createElement('a');

  a.href = `data:text/csv,${resp.body}`;
  a.setAttribute('download', filename);
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
};
